import { gql } from "@apollo/client";
import { KnowledgeBaseCategoryFragment } from "../../fragments/knowledge-base";

export const QUERY_FETCH_KNOWLEDGE_BASE_CATEGORIES = gql`
  query knowledgeBaseCategories {
    knowledgeBaseCategories {
      ...KnowledgeBaseCategoryFragment
    }
  }
  ${KnowledgeBaseCategoryFragment}
`;

export const QUERY_FETCH_KNOWLEDGE_BASE_LIST = gql`
  query knowledgeBasesList(
    $page: Int
    $pageSize: Int
    $categoryDocumentIds: [ID!]
    $knowledgeBaseTypeDocumentId: ID
  ) {
    knowledgebases: knowledgeBases_connection(
      filters: {
        category: { documentId: { in: $categoryDocumentIds } }
        knowledgeBaseType: { documentId: { eq: $knowledgeBaseTypeDocumentId } }
        publishedAt: { notNull: true }
      }
      pagination: { page: $page, pageSize: $pageSize }
      sort: "publicationDate:desc"
    ) {
      nodes {
        documentId
        title
        slug
        briefDescription
        publicationDate
        duration
        knowledgeBaseType {
          documentId
          type
        }
        category {
          documentId
          category
        }
        cover {
          url
          alternativeText
          mime
        }
      }
      pageInfo {
        page
        pageCount
        total
        pageSize
      }
    }
  }
`;

export const QUERY_FETCH_KNOWLEDGE_BASE_CATEGORY_BY_ID = gql`
  query knowledgeBaseCategory($documentId: ID!) {
    knowledgeBaseCategory(documentId: $documentId) {
      ...KnowledgeBaseCategoryFragment
    }
  }
  ${KnowledgeBaseCategoryFragment}
`;

export const QUERY_VALID_CATEGORY_IDS_FOR_KNOWLEDGE_BASE_TYPE = gql`
  query validCategoryIdsForKnowledgeBaseType(
    $knowledgeBaseTypeDocumentId: ID!
  ) {
    validCategoryIdsForKnowledgeBaseType(
      knowledgeBaseTypeDocumentId: $knowledgeBaseTypeDocumentId
    )
  }
`;
